import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { DateTimePicker } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { forwardRef } from '@wordpress/element';
import { getSettings } from '@wordpress/date';

/**
 * Internal dependencies
 */
import InspectorPopoverHeader from '../inspector-popover-header';
function PublishDateTimePicker({
  onClose,
  onChange,
  ...additionalProps
}, ref) {
  return createElement("div", {
    ref: ref,
    className: "block-editor-publish-date-time-picker"
  }, createElement(InspectorPopoverHeader, {
    title: __('Publish'),
    actions: [{
      label: __('Now'),
      onClick: () => onChange?.(null)
    }],
    onClose: onClose
  }), createElement(DateTimePicker, {
    startOfWeek: getSettings().l10n.startOfWeek,
    onChange: onChange,
    ...additionalProps
  }));
}
export default forwardRef(PublishDateTimePicker);
//# sourceMappingURL=index.js.map